import React, { FC } from "react";
import {
  PageEnum,
  SuppliersComplexReportSearchParamsModel,
} from "../../../models";
import {
  getPageNameByPageId,
  getSystemLanguageId,
  getUserId,
} from "../../../utils";
import { searchReportSuppliersPayments } from "../../../serviceBroker/suppliersReportApiServiceBroker";
import {
  ReportPage,
  ReportSuppliersComplexSearchPanel,
} from "../../../components";

export const ReportSuppliersPayments: FC = () => {
  const initialState: SuppliersComplexReportSearchParamsModel = {
    Lang: getSystemLanguageId(),
  };
  return (
    <ReportPage
      InitialState={initialState}
      SearchApi={searchReportSuppliersPayments}
      searchHeader={getPageNameByPageId(PageEnum.ReportSuppliersPayment)}
      SearchPanel={ReportSuppliersComplexSearchPanel}
      formId={PageEnum.ReportSuppliersPayment}
    />
  );
};
